var _defs, _rect, _rect2, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconPortfolio(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 166.15 166.15",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        stroke: #fff;\n        stroke-width: 2.77px;\n      }\n\n      .cls-1, .cls-2 {\n        fill: none;\n      }\n\n      .cls-3 {\n        fill: #fff0d7;\n      }\n\n      .cls-2 {\n        stroke: #ffc557;\n        stroke-linecap: round;\n        stroke-linejoin: round;\n        stroke-width: 4.15px;\n      }\n\n      .cls-4 {\n        clip-path: url(#clippath);\n      }\n    "), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M83.08,38.83v44.25h44.25c0-24.44-19.81-44.25-44.25-44.25Z"
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 0,
    y: 0,
    width: 166.15,
    height: 166.15,
    rx: 44.31,
    ry: 44.31,
    shapeRendering: "crispEdges"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 1.38,
    y: 1.38,
    width: 163.38,
    height: 163.38,
    rx: 42.92,
    ry: 42.92,
    shapeRendering: "crispEdges"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 83.08,
    cy: 83.08,
    r: 44.25
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "83.08 38.83 83.08 83.08 127.32 83.08"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 83.08,
    y1: 83.08,
    x2: 54.28,
    y2: 116.66
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    className: "cls-4"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 105.34,
    y1: 104.08,
    x2: 148.32,
    y2: 61.09
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 99.16,
    y1: 97.9,
    x2: 142.14,
    y2: 54.91
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 92.98,
    y1: 91.72,
    x2: 135.96,
    y2: 48.73
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 86.8,
    y1: 85.54,
    x2: 129.78,
    y2: 42.55
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 80.62,
    y1: 79.35,
    x2: 123.6,
    y2: 36.37
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 74.44,
    y1: 73.17,
    x2: 117.42,
    y2: 30.19
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 68.26,
    y1: 66.99,
    x2: 111.24,
    y2: 24.01
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 62.08,
    y1: 60.81,
    x2: 105.06,
    y2: 17.83
  }))), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M83.08,38.83v44.25h44.25c0-24.44-19.81-44.25-44.25-44.25Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPortfolio);
export default __webpack_public_path__ + "static/media/icon-portfolio.b4df58b01ca0ea8cfeb37570d5bd0f41.svg";
export { ForwardRef as ReactComponent };